let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kNZr8")).then(() => parcelRequire('847Yj'));